module.exports = __webpack_public_path__ + "assets/layers_white.38d6e1d8.svg";